// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Y4-z","dimensionLabel":"Z4-z","styleChooserControlWrapper":"_4-z","styleChooserControl":"a5-z","disabled":"b5-z","giftCard":"c5-z","styleChooserText":"d5-z"};